import type { Category } from "@/constants/categories";

type HomeCareProduct = {
  id: string;
  name: string;
  categorySlug: Category["slug"];
  brand: string;
  price: number;
  unit: string;
  image: string;
};

const IMG = {
  home: "https://images.unsplash.com/photo-1581578731548-c64695cc6952?crop=entropy&cs=srgb&fm=jpg&q=85",
};

const item = (
  id: string,
  name: string,
  brand: string,
  unit: string,
  price: number,
): HomeCareProduct => ({
  id,
  name,
  categorySlug: "home-care",
  brand,
  unit,
  price,
  image: IMG.home,
});

export const HOMECARE_PRODUCTS: HomeCareProduct[] = [
  // Falcon wraps & foils
  item("hc-falcon-cling-200", "Falcon Cling Film", "Falcon", "200m", 8.99),
  item("hc-falcon-cling-300", "Falcon Cling Film", "Falcon", "300m", 11.99),
  item("hc-falcon-aluminium-200", "Falcon Aluminium Foil", "Falcon", "200m", 12.99),
  item("hc-falcon-aluminium-75", "Falcon Aluminium Foil", "Falcon", "75m", 7.99),
  item("hc-falcon-food-storage", "Falcon Food Storage Bags", "Falcon", "50 pcs", 6.49),
  item("hc-falcon-zipper-bags", "Falcon Zipper Bags", "Falcon", "40 pcs", 5.99),
  item("hc-falcon-baking-paper", "Falcon Baking Paper", "Falcon", "10m", 5.49),
  item("hc-falcon-oven-bags", "Falcon Oven Bags", "Falcon", "8 pcs", 4.99),
  item("hc-falcon-freezer-bags", "Falcon Freezer Bags", "Falcon", "50 pcs", 6.99),
  item("hc-falcon-multipurpose-bags", "Falcon Multipurpose Bags", "Falcon", "100 pcs", 7.49),

  // Cleaning
  item("hc-pledge-wood-lavender", "Pledge Aerosol Wood Lavender", "Pledge", "330ml", 6.99),
  item("hc-dettol-surface-cleaner", "Dettol Surface Cleaner", "Dettol", "500ml", 5.99),
  item("hc-spray-glass-cleaner", "Glass Cleaner Spray", "Mr Muscle", "500ml", 4.99),
  item("hc-dishwash-liquid", "Dishwashing Liquid", "Fairy", "500ml", 4.49),

  // Garbage bags & misc
  item("hc-garbage-bags-large", "Garbage Bags Large", "Falcon", "30 pcs", 5.99),
  item("hc-garbage-bags-medium", "Garbage Bags Medium", "Falcon", "50 pcs", 5.49),
  item("hc-tissue-rolls-6pk", "Tissue Rolls", "Fine", "6 pack", 7.99),
  item("hc-kitchen-towel", "Kitchen Paper Towel", "Fine", "2 rolls", 4.99),

  // Baking & kitchen accessories
  item("hc-silver-cake-board", "Silver Cake Board Round", "Generic", "10 inch", 3.99),
  item("hc-cupcake-liners", "Cupcake Liners", "Falcon", "100 pcs", 3.49),
  item("hc-food-container-set", "Food Container Set", "Lock & Lock", "3 pcs", 12.99),

  // Fresheners & misc home
  item("hc-air-freshener-lavender", "Air Freshener Lavender", "Glade", "300ml", 4.99),
  item("hc-sponge-scourers", "Sponge Scourers", "Scotch-Brite", "6 pcs", 3.99),
  item("hc-mop-refill", "Mop Refill Pad", "Vileda", "1 pc", 6.99),
  item("hc-toilet-cleaner", "Toilet Cleaner", "Harpic", "500ml", 4.49),
  item("hc-fabric-softener", "Fabric Softener", "Comfort", "1L", 7.99),
  item("hc-laundry-detergent", "Laundry Detergent", "Persil", "2L", 12.99),
  item("hc-bleach", "Bleach", "Domestos", "750ml", 4.99),
];
